import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_breadcrumps-arrow.svg",
  "use": "16_breadcrumps-arrow.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_breadcrumps-arrow.svg\"><rect width=\"16\" height=\"16\" transform=\"translate(0 16) rotate(-90)\" style=\"fill:none\" /><path d=\"M10.65,8,7.17,11.48l-.82-.83L9,8,6.35,5.35l.82-.83Z\" style=\"fill:#5f5e59\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol